module.exports = __webpack_public_path__ + "static/media/aviso-feriado-carnaval-2026.4c87ce53.png";